import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["marathon-pacing"]!;

export function Body() {
  return (
    <>
      <p>
        The start of a marathon feels easy. The crowd is loud, your legs are fresh and the pace
        on your watch looks almost too slow. A large study of recreational runners shows what
        that early pace can cost you later.
      </p>

      <h2>What the researchers did</h2>
      <p>
        Researchers used the training logs of more than 25,000 recreational runners before
        big-city marathons. From each runner's fastest efforts over several distances in
        training, they estimated critical speed: roughly the fastest pace you can hold before
        fatigue starts to build up steadily. Then they compared race pace with that number.
      </p>

      <h2>What they found</h2>
      <p>
        On average, the runners ran their marathon at about 85 percent of their critical speed.
        Faster runners ran closer to it. Runners finishing in around two and a half hours ran
        at about 93 percent, while runners finishing in around six hours ran at about 79
        percent.
      </p>
      <p>
        The first half mattered. Runners who ran the first half faster than about 94 percent of
        their critical speed, and especially those who ran it faster than their critical speed,
        were much more likely to slow down by more than 25 percent in the second half.
      </p>

      <h2>What it means for you</h2>
      <p>
        Plan your first half at a pace you could hold for much longer than you need to. If you
        feel strong after 25 to 30 km, you can still speed up. Time lost by going out too fast
        is much harder to win back.
      </p>
      <p>
        Practise race pace on your long runs, so you know how it should feel when you are
        fresh. On race day, check your pace in the first kilometres and slow down if you are
        clearly faster than planned.
      </p>

      <h2>What the study can't tell you</h2>
      <p>
        Critical speed was estimated from training data, not measured in a lab. The study shows
        a link between a fast first half and slowing down, but some runners may have started
        fast because they felt good, and slowed for other reasons such as heat or fuelling.
      </p>

      <h2>How we use it</h2>
      <p>
        PX7 Training estimates your race time from your latest assessment. Use that estimate to
        set your race pace, and start at or slightly slower than it. Your long runs in the final
        weeks give you the chance to try that pace before race day.
      </p>

      <h2>Source</h2>
      <ul>
        <li>
          Smyth & Muniz-Pumares (2020), Calculation of critical speed from raw training data in
          recreational marathon runners.{" "}
          <a href="https://doi.org/10.1249/MSS.0000000000002412">Medicine & Science in Sports & Exercise</a>.
        </li>
      </ul>
    </>
  );
}
